import { render, staticRenderFns } from "./PromotionHistoryResume.vue?vue&type=template&id=266d337d&"
import script from "./PromotionHistoryResume.vue?vue&type=script&lang=js&"
export * from "./PromotionHistoryResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports